module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("Also by Mark Bowden:")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Doctor Dealer")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Bringing the Heat")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Black Hawk Down")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Killing Pablo")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Finders Keepers")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Road Work")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Guests of the Ayatollah")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 60
// module chunks = 0